import React, { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./type";
import SugarBlastUtils from "./utils";

export const SugarBlastRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  return (
    <>
      <h5 className="card-title">Game Rule</h5>
      <p className="card-text">
        Sugar Blast relies on eliminating candies to get a winning combination.
        The more winning combinations achieved, the higher the winnings!
      </p>
      <p className="card-text">
        At the start of every play, candies are frozen behind a block of ice
        across the game board.
        <br />
        Fire up to 3 cannon bombs to start the game. Each cannon bomb lands on a
        random position and breaks everything within a 3x3 grid.
      </p>
      <p className="card-text">
        Each candy's winning combination payout are as according to the Paytable
        below.
      </p>
      <div className="card-text">
        <div className="row">
          {Object.entries(payouts).map(([symbol, payout], i) => (
            <div key={symbol} className="col-6 col-md-3 pb-3">
              <div className="row justify-content-center">
                <div className="symbol">
                  {SugarBlastUtils.convertSymbol(+symbol)}
                </div>
              </div>
              <div className="row justify-content-center">{payout}</div>
            </div>
          ))}
        </div>
      </div>
      <p className="card-text">
        On every play, any combination of 4 or more of the same candy symbols
        aligned horizontally or vertically will result in a winning combination
      </p>
      <p className="card-text">
        After every matching candy combinations, the candy symbols will blast
        off the map, allowing symbols above them to cascade down into a new
        play.
      </p>
      <p className="card-text">
        Additional winning combinations will be tallied in every round until no
        more winning combination can be tallied.
      </p>
      <p className="card-text">
        During a round, each spin or successful combination increases the
        progress bar for free spins.
      </p>
      <p className="card-text">
        Buy free spin with {buyFreeSpinRate}x of bet amount to have free spin
        and high chance to win more.
      </p>
      <p className="card-text">
        Earn free spin at level below <br />
        <table className="table table-striped w-50 ms-5">
          <colgroup>
            <col width="10%" />
            <col width="10%" />
          </colgroup>
          <thead>
            <tr>
              <th>Level</th>
              <th>Earn Free Spin</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(givenFreeSpin)
              .sort((a, b) => +a[0] - +b[0])
              .map(([level, freeSpin], i, all) => (
                <tr key={`${level}-${i}`}>
                  <td>
                    {level} {all.length - 1 === i ? " or above" : ""}
                  </td>
                  <td>{freeSpin}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </p>
    </>
  );
};
